import React, { Fragment, useEffect, useRef, useState } from "react"
import { FaCamera } from "react-icons/fa"
import { BiSolidCameraOff } from "react-icons/bi"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button } from "components"
import classes from "./FuwCamera.module.scss"

const FuwCamera = props => {
  const {
    setTab,
    setFiles,
    originalFiles
  } = props

  const [t] = useTranslation()

  const [snapShot, setSnapShot] = useState(null)
  const [error, setError] = useState("")

  const streamRef = useRef(null)
  const videoRef = useRef(null)
  const unmount = useRef(false)

  const startWebcam = async () => {
    try {
      const stream =
        await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: { facingMode: "environment" }
        })

      if (unmount.current) return

      streamRef.current = stream

      videoRef.current.srcObject = stream

      videoRef.current.play()
    } catch (err) {
      console.log(err.message)

      err.message === "Permission denied"
        ? setError(t("برنامه_اجازه_دسترسی_به_دوربین_ندارد"))
        : setError(t("دوربین_در_دسترس_نیست"))

    }
  }

  const handleSnapshot = () => {
    const canvas = document.createElement("canvas")

    const context = canvas.getContext("2d")

    canvas.width = videoRef.current.offsetWidth

    canvas.height = videoRef.current.offsetHeight

    context.drawImage(
      videoRef.current,
      0,
      0,
      videoRef.current.offsetWidth,
      videoRef.current.offsetHeight
    )

    canvas.toBlob((blob) => {
      const id = (Math.random() * 10000) | 0

      setSnapShot({
        id,
        isFile: true,
        edited: false,
        blob,
        name: `webcam-${id}.jpg`,
        size: blob.size,
        url: URL.createObjectURL(blob),
        type: blob.type,
        uploadProgress: 0,
        uploadFailed: false
      })
    }, "image/jpeg")
  }

  const handleNext = () => {
    setFiles(prev => {
      const newFiles = [...prev, snapShot]

      originalFiles.current = newFiles

      return newFiles
    })

    setTab("files")
  }

  useEffect(() => {
    unmount.current = false

    startWebcam()

    return () => {
      unmount.current = true

      const tracks =
        streamRef.current?.getTracks() || []

      tracks.forEach(track => track.stop())
    }
  }, [])

  return (
    <Fragment>
      <div className={classes["container"]}>
        <div className={classes["wrapper"]}>
          {!error
            ?
            <Fragment>
              {
                snapShot !== null &&
                <img
                  className={classes["snapshot"]}
                  src={snapShot.url}
                  alt=""
                />
              }
              <video
                autoPlay
                playsInline
                ref={videoRef}
                className={clsx(
                  classes["video"],
                  snapShot !== null && classes["hide"]
                )}
              />
            </Fragment>
            :
            <div className={classes["no"]}>
              <BiSolidCameraOff size={30} />
              {error}
            </div>
          }
        </div>
      </div>

      {snapShot !== null
        ?
        <div className={classes["footer-2"]}>
          <Button
            onClick={() => setSnapShot(null)}
            color="danger"
          >
            {t("انصراف")}
          </Button>
          <Button
            color="success"
            onClick={handleNext}
          >
            {t("بعدی")}
          </Button>
        </div>
        :
        <div className={classes["footer-1"]}>
          <Button
            disabled={!!error}
            onClick={handleSnapshot}
          >
            <FaCamera />
          </Button>
        </div>
      }
    </Fragment>
  )
}

export default FuwCamera